import { useEffect, useMemo, useState } from "react";

import { listBoards, type Board } from "../data/boards";
import { LoadingClock } from "./LoadingClock";

export const QuickBoardsTab = () => {
  const [boards, setBoards] = useState<Board[]>([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    listBoards()
      .then(setBoards)
      .catch(() => setError("Não foi possível carregar os painéis."))
      .finally(() => setLoading(false));
  }, []);

  const visibleBoards = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();
    return boards
      .slice()
      .sort(
        (left, right) =>
          new Date(right.updatedAt).getTime() - new Date(left.updatedAt).getTime(),
      )
      .filter((board) =>
        normalizedQuery ? board.title.toLowerCase().includes(normalizedQuery) : true,
      )
      .slice(0, 5);
  }, [boards, query]);

  if (loading) {
    return (
      <div style={{ padding: 20 }}>
        <LoadingClock label="Carregando painéis..." />
      </div>
    );
  }

  return (
    <div style={{ padding: 20, display: "grid", gap: 16 }}>
      <div>
        <h2 style={{ margin: "0 0 8px" }}>Meus painéis</h2>
        <p style={{ margin: 0, color: "#58727c", lineHeight: 1.5 }}>
        </p>
      </div>

      <input
        aria-label="Buscar painéis"
        placeholder="Buscar painéis"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
        style={{
          width: "100%",
          boxSizing: "border-box",
          padding: "12px 14px",
          borderRadius: 12,
          border: "1px solid #d9e4ea",
          fontSize: 14,
          outline: "none",
        }}
      />

      {error ? (
        <p style={{ margin: 0, color: "#c0392b" }}>{error}</p>
      ) : null}

      <div style={{ display: "grid", gap: 10 }}>
        {visibleBoards.length ? (
          visibleBoards.map((board) => (
            <button
              key={board.id}
              type="button"
              onClick={() =>
                window.open(`/app?board=${board.id}`, "_blank", "noopener,noreferrer")
              }
              style={{
                width: "100%",
                boxSizing: "border-box",
                textAlign: "left",
                padding: "12px 14px",
                borderRadius: 14,
                border: "1px solid #d9e9ee",
                background: "#fff",
                cursor: "pointer",
              }}
            >
              <strong style={{ display: "block", marginBottom: 4 }}>
                {board.title}
              </strong>
              <small style={{ color: "#58727c" }}>
                Atualizado: {new Date(board.updatedAt).toLocaleString("pt-BR")}
              </small>
            </button>
          ))
        ) : (
          <p style={{ margin: 0, color: "#58727c" }}>
            Nenhum painel encontrado.
          </p>
        )}
      </div>

      <p style={{ margin: 0, color: "#58727c", fontSize: 13 }}>
        Mostrando os 5 painéis mais recentes.
      </p>

      <a
        href="/app/boards"
        style={{
          display: "flex",
          width: "100%",
          boxSizing: "border-box",
          alignItems: "center",
          justifyContent: "center",
          minHeight: 44,
          padding: "0 14px",
          borderRadius: 12,
          background: "#eff7ff",
          color: "#004fc9",
          fontWeight: 700,
          textDecoration: "none",
        }}
      >
        Ver todos os painéis
      </a>
    </div>
  );
};
